module.exports = __webpack_public_path__ + "static/media/server-error.d01e640f.jpg";